export class AppConfig {
  /**
   * .envのREACT_APP_MODEに設定されているUI起動モード
   */
  static readonly MODE = process.env.REACT_APP_MODE;
  /**
   * オフラインモード
   */
  static readonly MODE_OFFLINE = "offline";
  /**
   * クラウドモード
   */
  static readonly MODE_CLOUD = "cloud";

  /**
   * 利用規約有無
   */
  static readonly LINK_TERMS_ENABLED =
    typeof process.env.REACT_APP_TERMS_ENABLED !== "undefined" &&
    process.env.REACT_APP_TERMS_ENABLED === "true"
      ? true
      : false;

  /**
   * 紹介報告有無
   */
  static readonly LINK_INCIDENTS_ENABLED =
    typeof process.env.REACT_APP_INCIDENTS_ENABLED !== "undefined" &&
    process.env.REACT_APP_INCIDENTS_ENABLED === "true"
      ? true
      : false;

  /**
   * ファイルアップロード対象拡張子
   */
  static readonly UPLOAD_FILES_EXTENSION =
    ".GDS,.GEV,.GSD,.GSE,.DAE,.DAD,.DSE,.DSD,.CSV";

  /**
   * 最大アップロードファイルサイズ
   */
  static readonly MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 20;

  /**
   * 通知確認間隔(msec)
   */
  static readonly NOTICES_INTERVAL = 5000;
  /**
   * 非操作タイムアウト(msec)
   */
  static readonly UNOPERATED_TIMEOUT = 30 * 60 * 1000;

  /**
   * 最大プロジェクト数
   */
  static readonly MAX_PROJECTS = 30;
  /**
   * 最大ファイル数
   */
  static readonly MAX_FILES = 50;
  /**
   * 最大選択チャネル数
   */
  static readonly MAX_SELECT_CHANNELS = 20;

  /**
   * Cookie同意Cookie名
   */
  static readonly COOKIE_CONSENT_COOKIE_NAME = "AIBatchCookieConsent";
}

export class Locale {
  /**
   * 表示言語初期値
   * ブラウザの設定を使用する
   */
  static readonly DEFAULT = navigator.language;
  /**
   * 表示言語が存在しない場合の言語
   */
  static readonly NOTEXIST = "en";
  /**
   * 表示言語定義
   * ja : Japanese
   * en : English
   */
  static readonly LOCALES = [
    { label: "Japanese", lang: "ja" },
    { label: "English", lang: "en" },
  ];
}

export class MainSpace {
  static readonly PROJECTS: number = 0;
  static readonly NOTICE: number = 1;
  static readonly LISENCE: number = 2;
  static readonly HELP: number = 3;
}

export class Projects {
  static readonly PROJECT_LIST: number = 0;
  static readonly PROJECT_DETAIL: number = 1;
}

export class ProjectDetail {
  static readonly FILES: number = 0;
  static readonly CREATE_MODEL: number = 1;
  static readonly MODEL_PROPERTY: number = 2;
  static readonly TEST_MODEL: number = 3;
  static readonly RESULT_TEST_MODEL: number = 4;
  static readonly DOWNLOAD_MODEL: number = 5;
  static readonly CREATE_PROFILE: number = 6;
  static readonly RESULT_PROFILE: number = 7;
  static readonly DOWNLOAD_PROFILE: number = 8;
}

export class Files {
  static readonly FILE_LIST: number = 0;
  static readonly CHART_LIST: number = 1;
}

export class ProjectStatus {
  static readonly NONE = "none";
  static readonly DOING = "doing";
  static readonly DONE = "done";
}

export class ModelSelect {
  static readonly UNUSED = 0;
  static readonly OK = 1;
  static readonly NG = 2;
}

export class ProfileSelect {
  static readonly UNUSED = 0;
  static readonly USE = 1;
}

export class ChartList {
  /**
   * チャートテーブルLeft Margin
   */
  static readonly TABLE_MARGIN_LEFT = 0;
  /**
   * 表示対象最大データ数(モデル作成、プロファイル作成、モデルテスト)
   */
  static readonly MAX_DATA_NUM = 30000;

  /**
   * ファイルチャート幅
   */
  static readonly FILES_WIDTH = 320;
  /**
   * ファイルチャート高さ
   */
  static readonly FILES_HEIGHT = 240;

  /**
   * モデル作成チャート幅
   */
  static readonly MODEL_WIDTH = 320;
  /**
   * モデル作成チャート高さ
   */
  static readonly MODEL_HEIGHT = 240;

  /**
   * モデルテストチャート幅
   */
  static readonly TEST_MODEL_WIDTH = 320;
  /**
   * モデルテストチャート高さ
   */
  static readonly TEST_MODEL_HEIGHT = 240;

  /**
   * モデルテスト結果チャート幅
   */
  static readonly RESULT_TEST_MODEL_WIDTH = 320;
  /**
   * モデルテスト結果チャート高さ
   */
  static readonly RESULT_TEST_MODEL_HEIGHT = 240;

  /**
   * プロファイル作成チャート幅
   */
  static readonly PROFILE_WIDTH = 320;
  /**
   * プロファイル作成チャート高さ
   */
  static readonly PROFILE_HEIGHT = 240;

  /**
   * プロファイル作成結果チャート幅
   */
  static readonly RESULT_PROFILE_WIDTH = 480;
  /**
   * プロファイル作成結果チャート高さ
   */
  static readonly RESULT_PROFILE_HEIGHT = 360;

  /**
   * 凡例表示有無
   */
  static readonly LEGEND_SHOW = false;
  /**
   * 凡例表示位置
   * "bottom" | "right" | "inset"
   */
  static readonly LEGEND_POSITION = "bottom";

  /**
   * ツールチップ表示有無
   */
  static readonly TOOLTIP_SHOW = false;
  /**
   * ツールチップグループ化有無
   * falseの場合、重なっているデータは先頭のみ表示
   */
  static readonly TOOLTIP_GROUPED = false;

  /**
   * チャート一覧間引き閾値
   */
  static readonly CHART_LIST_THRESHOLD = 50;

  /**
   * リサイズ有無
   */
  static readonly RESIZE_ENABLED = false;
}

export class ChartDialogConfig {
  /**
   * チャートダイアログ範囲補正
   */
  static readonly CHAERT_DIALOG_AREA_CORRECTION = 4 / 5;

  /**
   * 一回あたりのX軸拡大率
   */
  static readonly CHART_X_AXIS_SCALE_RATE = 0.25;

  /**
   * 一回あたりのY軸拡大率
   */
  static readonly CHART_Y_AXIS_SCALE_RATE = 0.25;

  /**
   * トリミングチャート間引き閾値
   */
  static readonly TRIMMING_CHART_THRESHOLD = 300;

  /**
   * Y軸範囲補正
   */
  static readonly CHART_Y_AXIS_RANGE_CORRECTION = 0.5;

  /**
   * Y軸の最大最小値が0の場合、最大最小値に設定します
   */
  static readonly CHART_Y_AXIS_ZERO_VALUE = 50;

  /**
   * 最大Y軸設定値
   */
  static readonly MAX_Y_AXIS_VALUE = Number.MAX_SAFE_INTEGER;

  /**
   * 最小Y軸設定値
   */
  static readonly MIN_Y_AXIS_VALUE = Number.MIN_SAFE_INTEGER;
}

/**
 * any型
 */
// eslint-disable-next-line
export type AnyType = any;

/**
 * DataGridの選択行
 */
export type DataGridCheckRow = AnyType;
